import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import List from './list';
import Form from './form';

const Component = () => (
  <Switch>
    <Route path="/subscriptions/add"><Form /></Route>
    <Route path="/subscriptions/edit/:id"><Form /></Route>
    <Route path="/subscriptions"><List /></Route>
    <Redirect to="/subscriptions" />
  </Switch>
);

export default Component;
